import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PoMenuItem } from "@po-ui/ng-components";
import { environment } from "../../../environments/environment";
import { Subject } from "rxjs";

const API = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class MenuService {

    private reconstruirMenuSubject = new Subject<any>();
    reconstruirMenuObservable = this.reconstruirMenuSubject.asObservable();

    constructor(private http: HttpClient) { }

    reconstruirMenu() {
        this.reconstruirMenuSubject.next(true);
    }
    
    getMenuSchema() {
        return this.http.get<PoMenuItem[]>(API + "/v1/schema-builder/get-menu-schema");
    }
}